import './ShortcutsDialog.scss';

import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { Dialog, DialogType } from '@fluentui/react';

import { ShortcutManager } from '../../util/ShortcutManager';

export interface ShortcutsDialogProps {}

export class ShortcutsDialog {
  public static show(options?: ShortcutsDialogProps) {
    const dialogNode = document.createElement('div');
    const close = () => {
      ReactDOM.unmountComponentAtNode(dialogNode);
      dialogNode.remove();
    };
    ReactDOM.render(<ShortcutsDialogInternal {...options} close={close} />, dialogNode);
  }
}

class ShortcutsDialogInternal extends React.Component<ShortcutsDialogProps & { close: () => void }> {
  public render(): JSX.Element {
    const groups = ShortcutManager.getInstance().getRegistrations();
    return (
      <Dialog
        hidden={false}
        dialogContentProps={{
          type: DialogType.normal,
          title: 'Keyboard shortcuts',
        }}
        minWidth={860}
        onDismiss={this.props.close}
      >
        <div className="flex justify-center">{Object.keys(groups).map((key) => this.renderGroup(key, groups[key]))}</div>
      </Dialog>
    );
  }

  public renderGroup(name: string, shortcuts: { title: string; keys: string }[]): JSX.Element {
    return (
      <table key={name} className="keyboard-shortcut-group">
        <thead>
          <tr>
            <th />
            <th scope="col">{name}</th>
          </tr>
        </thead>
        <tbody>
          {shortcuts.map((shortcut, index) => {
            return (
              <tr key={index}>
                <td className="keys-definition">
                  <span>
                    {shortcut.keys.split(' ').map((s, i) => (
                      <kbd key={i}>{s}</kbd>
                    ))}
                  </span>
                </td>
                <td className="keys-description">{shortcut.title}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}
